import React, { Fragment } from "react";
import { Link } from "react-router-dom";

const FeatureContent = [
  {
    icon: "icon_17",
    title: "Data Science",
    desc: `Applying advanced analytics techniques and scientific principles to extract valuable information from data for business decision-making, strategic planning and other uses.`,
    routerPath:
      "https://www.simplilearn.com/tutorials/data-science-tutorial/what-is-data-science",
    // arrow: "icon_20",
    // fadeUp: "fade-up",
    // dataDelay: "",
  },
  {
    icon: "icon_18",
    title: "Machine Learning",
    desc: `Artificial intelligence (AI) that allows software applications to become more accurate at predicting outcomes without being explicitly programmed to do so.`,
    routerPath:
      "https://www.techtarget.com/searchenterpriseai/definition/machine-learning-ML",
    // arrow: "icon_20",
    // fadeUp: "fade-up",
    // dataDelay: "100",
  },
  {
    icon: "icon_19",
    title: "Business Analyst",
    desc: ` Identifying business needs and determining solutions to business problems. `,
    routerPath:
      "https://www.techtarget.com/searchbusinessanalytics/definition/business-analytics-BA",
    // arrow: "icon_20",
    // fadeUp: "fade-up",
    // dataDelay: "200",
  },
];

const FancyFeatureEight = () => {
  return (
    <Fragment>
      <div className="row justify-content-center gx-xxl-5">
        {FeatureContent.map((val, i) => (
          <div
            key={i}
            className="col-lg-4 col-sm-6 d-flex mb-30"
            data-aos={val.fadeUp}
            data-aos-delay={val.dataDelay}
          >
            <div className="block-style-seven">
              <div className="icon d-flex align-items-end">
                <img src={`images/icon/${val.icon}.svg`} alt="" />
              </div>
              <a href={val.routerPath}>
                <h5>{val.title}</h5>
              </a>
              <p>{val.desc}</p>
              <Link to="/service-details" className="tran3s more-btn">
                <img src={`images/icon/${val.arrow}.svg`} alt="" />
              </Link>
            </div>
            {/* /.block-style-seven */}
          </div>
        ))}
      </div>
    </Fragment>
  );
};

export default FancyFeatureEight;
